import { defineStore } from "pinia";
import { AuthApiConnector } from "@/views/auth/services/auth-api-connector";
import { useSessionStore } from "@/modules/session/store";
import {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
} from "firebase/auth";

export const useAuthStore = defineStore("auth", () => {
  const sessionStore = useSessionStore();

  const register = async (email: string) => {
    try {
      await AuthApiConnector.register(email);
    } catch (e) {
      console.error(e, "AuthApi:register");

      throw e;
    }
  };

  const registerConfirm = async (payload: { email: string; code: string }) => {
    try {
      const { data } = await AuthApiConnector.registerConfirm({
        ...payload,
        type_id: 1, // 1 - with code, 2 - with query (code) - from invite
      });

      const { access_token, access_expired, refresh_token, refresh_expired } =
        data;

      sessionStore.setTokens({
        access_token: `Bearer ${access_token}`,
        access_expired: access_expired,
        refresh_token: `Bearer ${refresh_token}`,
        refresh_expired: refresh_expired,
      });
    } catch (e) {
      console.error(e, "AuthApi:registerConfig");

      throw e;
    }
  };

  const registerWithGoogle = async () => {
    try {
      const auth = getAuth();

      const provider = new GoogleAuthProvider();
      const { user }: any = await signInWithPopup(auth, provider);

      if (user) {
        sessionStore.setTokens({
          access_token: user.accessToken,
          access_expired: Date.now() + 3600000,
          refresh_token: user.refreshToken,
          refresh_expired: Date.now() + 86400000,
        });
      }
    } catch (e) {
      console.error(e, "AuthApi:GoogleAuth");

      throw e;
    }
  };

  const signAfterPaid = async (sessionId: string, type: string) => {
    try {
      const { data } = await AuthApiConnector.signAfterPaid({
        sessionId,
        type,
      });

      const { access_token, access_expired, refresh_token, refresh_expired } =
        data;

      sessionStore.setTokens({
        access_token: `Bearer ${access_token}`,
        access_expired: access_expired,
        refresh_token: `Bearer ${refresh_token}`,
        refresh_expired: refresh_expired,
      });
    } catch (e) {
      console.error(e, "AuthApi:signAfterPaid");

      throw e;
    }
  };

  return {
    signAfterPaid,
    register,
    registerConfirm,
    registerWithGoogle,
  };
});
